import CryptoJS from 'crypto-js';

export const encryptData = (input) => {
    var key = "kP1C3L?!1xHAm2?&dex";
    let encryptedData = '';
    const stringifiedInput = JSON.stringify(input); // Convert array to string
    for (let i = 0; i < stringifiedInput.length; i++) {
    encryptedData += String.fromCharCode(stringifiedInput.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return btoa(encryptedData);
};

export const generateSignature = (status, message) => {
    var secretKey = "kP1C3L?!1xHAm2?&dex";
    const data = status + '|' + message;
    console.log(data);
    return CryptoJS.HmacSHA256(data, secretKey).toString(CryptoJS.enc.Hex);
};

